import { Route, Routes } from 'react-router-dom';

import { LandingPage } from './routes/LandingPage';
import { ListenPage } from './routes/ListenPage';
import { NotFoundPage } from './routes/NotFoundPage';

export function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/s/:sessionId" element={<ListenPage />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}
